import { PaletteColor, Theme } from '@mui/material/styles';

/**
 * Tokens da cor como CSS vars (`var(--palette-*)`), nunca como valor literal.
 *
 * O tema roda com `cssVariables`, então `theme.palette.*` congela o esquema CLARO: tudo que era
 * calculado a partir daqui (cor de hover, borda, outline de foco) saía com valor de tema claro
 * também no dark — daí texto sumir no hover de botões/chips. As vars trocam sozinhas com o esquema.
 */
export default function getColors(theme: Theme, color?: string): PaletteColor {
  const palette = theme.vars!.palette;

  switch (color) {
    case 'secondary':
      return palette.secondary as PaletteColor;
    case 'error':
      return palette.error as PaletteColor;
    case 'warning':
      return palette.warning as PaletteColor;
    case 'info':
      return palette.info as PaletteColor;
    case 'success':
      return palette.success as PaletteColor;
    default:
      return palette.primary as PaletteColor;
  }
}
